module.exports = __webpack_public_path__ + "media/assets/images/personas/eva_schema-dc785b7925889f552ba1149155afb809.png";